import React, { useState } from 'react';
import { editAdvertPlan } from '../../redux/advertSlice';
import { Select } from '../../components/Select';
import { ADVERT_CITY_STORAGE_NAME, createHandlerWithStorage } from '../../helpers/localStorage';
import { getStorageData, UTCToString } from '../../helpers';
import { useDispatch, useSelector } from 'react-redux';
import { Input } from '../../components/Input';
import {ReactComponent as BinSvg} from '../../assets/bin.svg';
// import BinSvg from '../../assets/bin.svg';
import {ReactComponent as AcceptSvg} from '../../assets/accept.svg';
// import AcceptSvg from '../../assets/accept.svg';
import {ReactComponent as ArrowSvg} from '../../assets/wrap-arrow.svg';
// import ArrowSvg from '../../assets/wrap-arrow.svg';
import { Button } from '../../components/Button';
import OutsideClickHandler from 'react-outside-click-handler';

function getWeekDates(dateString) {
    const date = new Date(dateString);
    // Получаем день недели (0 - воскресенье, 6 - суббота)
    const dayOfWeek = date.getDay();
  
    // Находим понедельник текущей недели
    const monday = new Date(date);
    monday.setDate(date.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1));
  
    // Формируем список дат для всей недели
    const weekDates = [];
    for (let i = 0; i < 7; i++) {
      const currentDate = new Date(monday);
      currentDate.setDate(monday.getDate() + i);
      weekDates.push(currentDate.toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit', year: 'numeric' }));
    }
    return weekDates;
  }



const PlanItem = ({data, isCreate = false}) => {
    const typeStr = data.type === 'note' ? 'примечание' : 'дело'
    const dispatch = useDispatch();
    const [value, setValue] = useState(data.content);

    const deleteHandler = () => {
        if (window.confirm(`удалить ${typeStr}?`)) {
            dispatch(editAdvertPlan({_id: data._id, editType: 'delete'}))
        }
    }
    const blurHandler = () => {
        if (!isCreate && !value) {
            deleteHandler();
        }
        if (isCreate && value) {
            saveHandler();
            setValue('')
        }
    }
    const saveHandler = () => {
        const body = {...data, content: value, editType: 'update'};
        if (isCreate) {
            delete body._id;
        } else {
            delete body.city;
            delete body.dateString;
            delete body.type;
        }
        dispatch(editAdvertPlan(body));
    }

    return (
        <div>
            <Input onBlur={blurHandler} placeholder={`${isCreate ? `добавить новое` : `редактировать`} ${typeStr}`} value={value} changeHandler={(e) => setValue(e.target.value)} />
            {!isCreate && <BinSvg onClick={deleteHandler} width={24} height={24}/>}
            <AcceptSvg style={{display: data.content !== value ? 'block' : 'none'}} onClick={saveHandler} width={20} height={20}/>
        </div>
    )
}

export const Interviews = ({cities}) => {
    const dispatch = useDispatch();
    const advertPlans = useSelector((state) => state.advert.advertPlans);
    const [city, setCity] = useState(getStorageData(cities, ADVERT_CITY_STORAGE_NAME));
    const setCityHandler = createHandlerWithStorage(setCity, ADVERT_CITY_STORAGE_NAME);
    
    const thisCityPlans = advertPlans.filter(p => p.city === city);
    const sheduleList = thisCityPlans.filter(p => p.type === 'shedule');
    const noteList = thisCityPlans.filter(p => p.type === 'note');
    const toDoList = thisCityPlans.filter(p => p.type === 'to-do');


    const thisCityUTC = cities.find(c => c._id === city).UTC;
    const strUTC = UTCToString(thisCityUTC);
    let thisCityCurTime = null;
    try {
        thisCityCurTime = new Date().toLocaleString('ru', {timeZone: strUTC})
    } catch(e) {
        console.log('toLocaleStorage error:', e)
        thisCityCurTime = new Date().toLocaleString('ru')
    }
    const thisCityDate = thisCityCurTime.split(', ')[0].split('.').reverse().join('-');

    const [weekDate, setWeekDate] = useState(thisCityDate);

    const tableHeaders = ['неделя:', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб', 'вс'];
    const thisWeekDays = ['', ...getWeekDates(weekDate)]
    const setWeekHandler = (isNext = true) => {
        const d = new Date(thisWeekDays[isNext ? 7 : 1].split('.').reverse().join('-'));
        d.setDate( d.getDate() + (isNext ? 1 : -1) )
        setWeekDate(d.toLocaleDateString().split('.').reverse().join('-'));
    }

    const TableHeaders = () => {

        return (<>
            {tableHeaders.map((th, i, a) => <div key={th}>
                {i === 0 && <ArrowSvg width="20px" height="20px" onClick={() => setWeekHandler(false)} style={{cursor: 'pointer', transform: 'rotate(90deg)', marginRight: '4px', position: 'relative', top: '1px'}}/>}
                {th} {thisWeekDays[i].slice(0,5)}
                {i === a.length-1 && <ArrowSvg width="20px" height="20px" onClick={() => setWeekHandler(true)} style={{cursor: 'pointer', transform: 'rotate(270deg)', marginLeft: '4px', position: 'relative', top: '1px'}}/>}
            </div>)}
        </>)
    }

    const FIRST_WORK_HOUR = 10;
    const LAST_WORK_HOUR = 18;
    
    const TableBody = () => {
        const timeList = new Array(LAST_WORK_HOUR-FIRST_WORK_HOUR+1).fill(0).map((_,i) => `${FIRST_WORK_HOUR+i}:00`);

        const TableCell = ({isTime, timeStr, date}) => {
            const [isPopup, setPopup] = useState(null);

            const dateKey = `${date.split('.').reverse().join('-')}T${timeStr}`;
            const curContent = sheduleList.find(item => item.dateString === dateKey) || null;
            const [content, setContent] = useState(curContent?.content || '');

            const updateHandler = () => {
                const _id = curContent?._id;
                if (content !== curContent?.content && content) {   //create | update
                    const body = {
                        editType: 'update', _id, content, city, type: 'shedule', dateString: dateKey
                    }
                    if (!_id) {
                        delete body._id
                    } else {
                        delete body.city;
                        delete body.dateString;
                        delete body.type;
                    }
                    dispatch(editAdvertPlan(body))
                    return;
                }
                if (curContent && !content) {   //delete
                    if (window.confirm('Удалить план?')) {
                        dispatch(editAdvertPlan({editType: 'delete', _id}))
                    }
                }
            }

            return (
                <div className={`${isTime ? 'time':''} ${curContent ? 'exists':''} interviews-table__column`} onClick={curContent?() => setPopup(true):() => {}}>
                    {isTime && timeStr}
                    {!isTime && !curContent && <Button text="Добавить" onClick={() => setPopup(true)} />}
                    {!!curContent && <span>Запланировано</span>}
                    {isPopup && <OutsideClickHandler onOutsideClick={() => setPopup(false)}>
                        <textarea onBlur={updateHandler} value={content} onChange={(e) => setContent(e.target.value)} placeholder='Имена, номера промов' className='interviews-table__content-popup dark-theme-bg0' />
                        </OutsideClickHandler>}
                </div>
            )
        }

        return (<>
            {timeList.map(t => <React.Fragment key={t}>
                {thisWeekDays.map((d, i) => <TableCell key={`${d}T${t}`} isTime={!i} timeStr={t} date={d} />)}
            </React.Fragment>)}
        </>)
    }

    const newAdvertPlanData = {
        _id: 'null',
        city,
        content: '',
    }

    return (
        <div className="interviews">
            <div className="container">
                <div className="interviews__manager">
                    <Select
                        enums={cities}
                        value={city}
                        changeHandler={(e) => setCityHandler(e.target.value)}
                    />
                </div>
                <div className="interviews-table dark-theme-bg1">
                    <div className="interviews-table__section">
                        <TableHeaders />
                        <TableBody />
                    </div>
                    <div className="interviews-table__section">
                        <div className="interviews-table__subsection">
                            <h4 className='dark-theme-bg0'>Примечания</h4>
                            <div className="interviews-table__plan-list">
                                {noteList.map(note => <PlanItem key={note._id} data={note} />)}
                                <PlanItem key="new-note" isCreate={true} data={{...newAdvertPlanData, type: 'note'}} />
                            </div>
                        </div>
                        <div className="interviews-table__subsection">
                            <h4 className='dark-theme-bg0'>Список дел</h4>
                            <div className="interviews-table__plan-list">
                                {toDoList.map(plan => <PlanItem key={plan._id} data={plan} />)}
                                <PlanItem key="new-to-do" isCreate={true} data={{...newAdvertPlanData, type: 'to-do'}} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
